import * as React from 'react';
/**
 *
 * Original name: download
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A379
 *
 */
export const DownloadPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M56 52H8v4h48v-4Zm-25.949-4.55h3.9c2.695-11.679 14.524-15.5 14.644-15.54L48 30l-.588-1.911A28.5 28.5 0 0 0 34 37.863V11h-4v26.863a28.5 28.5 0 0 0-13.412-9.774l-1.18 3.821c.119.037 11.948 3.861 14.643 15.54Z", fill: "currentColor" })));
